// BroadcastList.js
import { connect } from 'react-redux';
import BroadcastList from '../component/BroadcastList.jsx';
import withRouter from '../component/WithRouter.jsx';

import setMessageExpanded from '../action/setMessageExpanded.js';
import fetchFeeds from '../action/fetchFeeds.js';
import getMessageList from '../selector/getMessageList.js';
import getUserData from '../selector/getUserData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getFeedName from '../selector/getFeedName.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { ProfileListType } from '../resource/profileConstants.js';
import getIsMatchedPathname from '../resource/getIsMatchedPathname.js';
import { PROFILE_FEED_REMOTE_CONFIG_KEY_MAP } from '../resource/profileConstants.js';
import { QueryPrefix, QueryType } from '../resource/feedConstants.js';

const mapStateToProps = (state, { userId, location }) => {
  const isOnPostDetail = getIsMatchedPathname({
    pathname: location?.pathname,
    dataKey: 'isOnPostDetail',
  });
  const isShortVideo = isOnPostDetail;
  const feedNameRemoteConfigKey =
    PROFILE_FEED_REMOTE_CONFIG_KEY_MAP[
      isShortVideo ? ProfileListType.SHORT : ProfileListType.STORY
    ];
  const feedName = getFeedName(
    state,
    feedNameRemoteConfigKey,
    '{USER_ID}',
    userId
  );
  const { feedNameWithQuery } = getSelectedQueryOptionObject(
    state,
    feedName,
    getSelectedFeedQueryOptions(state, feedNameRemoteConfigKey, undefined),
    getRemoteConfigData(
      state,
      `${feedNameRemoteConfigKey}_${QueryPrefix[QueryType.SORT]}`
    )?.[0]
  );
  const listPath = [
    'outbox',
    isShortVideo ? ProfileListType.SHORT : ProfileListType.STORY,
    userId,
  ];
  return {
    feedNameWithQuery,
    postCount: getMessageList(state, 'outbox', listPath, 'totalCount'),
    username: getUserData(state, userId, 'username'),
    nextPage: getMessageList(state, 'outbox', listPath, 'nextPage'),
    itemIds: getMessageList(state, 'outbox', listPath, 'itemIds'),
    isNextPageFetching: !!getNetworkingData(
      state,
      ['messages', userId, 'viewScope'],
      'isFetching'
    ),
    isShortVideo,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: payload => dispatch(fetchFeeds(payload)),
    closeBroadcastList: messageId =>
      dispatch(setMessageExpanded({ expandedField: null, messageId })),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BroadcastList)
);
